import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DialogRef,
  DialogService,
  DIALOG_DATA,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import {
  FeedbackType,
  SupportService,
} from '../../../services/support.service';

@Component({ standalone: false, 
  selector: 'cyborg-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
})
export class FeedbackModalComponent implements OnInit {
  public error: string;
  public submitted: boolean = false;
  public feedbackForm: FormGroup;
  public selectedType: FeedbackType = 'Support';
  public feedbackExplanations: Record<FeedbackType, string> = {
    Support:
      'Related to issues with deploying the hunt package content queries',
    Tuning:
      'Related to issues with a large number of false positives/negatives',
    Syntax: 'Related to issues with the output of the content queries',
    Request:
      'Related to requesting additional content, context or documentation',
  };

  public feedbackTypes: Array<FeedbackType> = Object.keys(
    this.feedbackExplanations
  ) as Array<FeedbackType>;

  constructor(
    private supportService: SupportService,
    public dialogRef: DialogRef,
    public dialog: DialogService,
    @Optional() @Inject(DIALOG_DATA) public data: { uuid: string }
  ) {}

  public ngOnInit(): void {
    this.feedbackForm = new FormGroup({
      message: new FormControl('', [Validators.required]),
      feedbackType: new FormControl('', [Validators.required]),
    });
  }

  public onSendFeedBack(): void {
    this.supportService
      .sendFeedbackEmail({
        type: this.feedbackForm.value.feedbackType,
        UUID: this.data.uuid,
        message: this.feedbackForm.value.message,
      })
      .subscribe(
        () => {
          this.submitted = true;
          this.feedbackForm.patchValue({
            subject: '',
            message: '',
          });
        },
        (error) => {
          this.error = error;
        }
      );
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
